import { notification } from 'antd'
import { createElement, FunctionComponent, useState } from 'react'
import { useContext, useContextSelector } from 'use-context-selector'

import api from 'services/api'
import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { Button } from 'components/ui/Button/Button'
import { Href } from 'components/ui/Href/Href'
import { Spinner } from 'components/ui/Spinner/Spinner'
import { clipboard } from 'utils/helpers/clipboard'
import { uploadFile } from 'utils/helpers/files/fileUpload'
import { PromoRoutesEnum } from 'shared/constants/routes'
import { SectionName } from 'types/types'

import { BlockWrap } from './BlockWrap/BlockWrap'
import { AdminInput } from './UI/Input/AdminInput'
import { getSectionReq } from './utils/getSectionReq'

import close from 'assets/img/gallery--close.svg'
import 'react-toastify/dist/ReactToastify.css'
import s from './Admin.module.scss'

export type BlockType = {
  id: number
  index: number
  type: SectionName
  children: JSX.Element
}

export const Admin = () => {
  const state = useContextSelector(PromoPageStateContext, (context) => context.state.sections)

  const ctx = useContext(PromoPageStateContext)

  const [isVisible, setVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [fileLoading, setFileLoading] = useState(false)
  const [publishLoading, setPublishLoading] = useState(false)

  const blockMapData = state.map((blockEl) => {
    if (blockEl.type === SectionName.faq) {
      return null
    } else {
      return (
        <div key={blockEl.index} className={s.blockWrap}>
          <BlockWrap type={blockEl.type}>
            {createElement(blockEl.menuComponent as unknown as FunctionComponent)}
          </BlockWrap>
        </div>
      )
    }
  })

  const handlePublishChanges = async () => {
    if (ctx.state.isChangesUpdatingBlocked) {
      notification.error({
        message: 'Ошибка',
        description: 'Начальные данные не были получены с сервера, поэтому нельзя опубликовать изменения.',
      })
      return
    }

    const sectionsReq = getSectionReq(ctx.state.sections)

    try {
      setPublishLoading(true)

      await api.requests.updateSections({ sections: sectionsReq })
      notification.success({
        message: 'Успешно',
        description: 'Изменения опубликованы',
      })
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: `Произошла ошибка: ${error}`,
      })
    } finally {
      setPublishLoading(false)
    }
  }

  const changeFileHandler = async (file: File) => {
    setFileLoading(true)

    const url = await uploadFile(file)

    if (url) {
      setInputValue(url)
      clipboard(url)
    }

    setFileLoading(false)
  }

  return (
    <>
      <button className={s.openButton} onClick={() => setVisible(true)}>
        AdminV2
      </button>

      {isVisible && (
        <div className={s.wrap}>
          <div>
            <div>
              <button className={s.closeButton} onClick={() => setVisible(false)}>
                <img src={close} alt="close" />
              </button>

              <div className={s.menu}>{blockMapData}</div>

              <div className={s.linksWrap}>
                <h5>Перейти к:</h5>

                <div className={s.links}>
                  <Href href={PromoRoutesEnum.conferences} target="_self" linkType="pathname">
                    {state.find((section) => section.type === SectionName.conferences)?.title}
                  </Href>
                  <Href href={PromoRoutesEnum.listSignBoardsSortingCenters} target="_self" linkType="pathname">
                    {state.find((section) => section.type === SectionName.sortingCenters)?.title}
                  </Href>
                  <Href href={PromoRoutesEnum.videoConnection} target="_self" linkType="pathname">
                    {state.find((section) => section.type === SectionName.contractors)?.title}
                  </Href>
                  <Href href={PromoRoutesEnum.eLock} target="_self" linkType="pathname">
                    {state.find((section) => section.type === SectionName.elock)?.title}
                  </Href>
                </div>
              </div>
            </div>

            <div className={s.fileWrap}>
              <AdminInput
                onChange={changeFileHandler}
                type="file"
                label="Файл для получения ссылки на него"
                disabled={fileLoading}
                labelSize="16px"
              />

              {fileLoading ? (
                <Spinner />
              ) : (
                <AdminInput value={inputValue} onChange={() => {}} label="Ссылка" disabled labelSize="16px" />
              )}
            </div>
          </div>

          <div className={s.buttonWrap}>
            <Button onClick={handlePublishChanges} disabled={publishLoading}>
              Опубликовать изменения
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
